import './styles.scss';

import { Fragment, ReactElement } from 'react';

import Table from '@/common/Table';
import TrainingReportPdfCityRow from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/TrainingReportPdfCityRow';
import TrainingReportPdfDriversTable from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/TrainingReportPdfDriversTable';
import { TrainingReportPdfData } from '@/features/PdfLayout/layouts/TrainingReport/utils';
import TrainingReportPdfTableHeader from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/TrainingReportPdfTableHeader';
import { usePdfLayout } from '@/features/PdfLayout';
import { visibleColumns } from '@/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/utils';

const TrainingReportPdfTable = (): ReactElement => {
  const { columns, cities } = usePdfLayout(({ state }) => state.data as TrainingReportPdfData);
  const cityColumns = visibleColumns(columns);

  return (
    <Table className="TrainingReportPdf-Table" header={<TrainingReportPdfTableHeader columns={columns} keys={cityColumns} />}>
      {cities.map((city, c) => (
        <Fragment key={`${city.key}-${c}`}>
          <TrainingReportPdfCityRow city={city} keys={cityColumns} />
          {city.drivers.length > 0 && (
            <Table.Row className="TrainingReportPdf-DriversRow" virtualize={false}>
              <Table.Cell className="DRIVERS" colSpan={cityColumns.length}>
                <TrainingReportPdfDriversTable columns={city.childColumns} drivers={city.drivers} />
              </Table.Cell>
            </Table.Row>
          )}
        </Fragment>
      ))}
    </Table>
  );
};

export default TrainingReportPdfTable;
